import {
  FETCH_SUBCATEGORYLIST_REQUEST,
  FETCH_SUBCATEGORYLIST_SUCCESS,
  FETCH_SUBCATEGORYLIST_FAILURE,
} from "./subcategoryListTypes";

const initialState = {
  loading: false,
  subcategoryList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBCATEGORYLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_SUBCATEGORYLIST_SUCCESS:
      return {
        loading: false,
        subcategoryList: action.payload,
        error: "",
      };
    case FETCH_SUBCATEGORYLIST_FAILURE:
      return {
        loading: false,
        subcategoryList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
